import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

// Analyse IA en masse des contrats qui ont des documents mais pas encore d'analyse.
export const AnalyzeAllButton = () => {
  const { hasPermission } = useAuth();
  const [status, setStatus] = useState(null);
  const timer = useRef(null);

  const poll = async () => {
    try {
      const { data } = await api.get("/contracts-ai/bulk-status");
      setStatus(data);
      if (data.job?.status === "running") { timer.current = setTimeout(poll, 5000); }
    } catch { /* silencieux */ }
  };
  useEffect(() => { poll(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const running = status?.job?.status === "running";
  const start = async () => {
    if (!window.confirm(`Analyser par IA ${status?.eligible || 0} contrat(s) ? Compte ≈ 20 s par contrat (appel Gemini facturé sur ta clé).`)) return;
    try {
      await api.post("/contracts-ai/bulk-analyze");
      toast.success("Analyse lancée en arrière-plan — tu peux continuer à travailler");
      poll();
    } catch (e) { toast.error(apiError(e)); }
  };

  if (!hasPermission("contracts.write") || !status || (!running && !status.eligible)) return null;
  const j = status.job;
  return (
    <Button variant="outline" onClick={start} disabled={running} data-testid="contracts-ai-bulk-btn"
            title={j && !running ? `Dernière analyse : ${j.done}/${j.total}, ${j.errors} erreur(s), ${j.with_gaps} avec écarts` : undefined}>
      {running ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
      {running ? `Analyse IA ${j.done}/${j.total}…` : `Analyser ${status.eligible} contrat(s) par IA`}
    </Button>
  );
};
